<template>
  <div class="stripe-main p-2">
    <div class="row no-gutters">
      <div class="col-md-3 col-sm-6">
        <div class="row-price no-gutters" :class="pClass">
          <div>
            <strong class="mr-2">LSX</strong>
            <span class="badge" :class="mClass">{{ mStatus }}</span>
            <h2><i class="fas" :class="icon"></i> {{ currentPrice | amountFormat }}</h2>
          </div>
          <div class="price">
            <div class="text-right"><span>{{ diff | amountFormat }}</span></div>
            <div class="text-right">(<span>{{ per | amountFormat }}%</span>)</div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 text-right">
        <span>ປະລິມານ ('000 ຮຸ້ນ)</span>
        <h3>{{ volume | amountFormat }}</h3>
      </div>
      <div class="col-md-3 col-sm-6 text-right">
        <span>ມູນຄ່າ (ລ້ານກີບ)</span>
        <h3>{{ value | amountFormat }}</h3>
      </div>
      <div class="col-md-3 col-sm-6 text-right">
        <div>ຂໍ້ມູນຫລ້າສຸດ</div>
        <div class="pt-1"><strong>{{ pDate }}</strong></div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from '@/moment'
import LottoService from '@/services/lottoService'

export default {
  name: 'LastPriceIndex',
  data() {
    return {
      interval: null,
      today: moment().format("YYYY-MM-DD"),
      price: null
    }
  },
  computed: {
    pDate() {
      return moment(this.price?.time).format("DD MMM YYYY HH:mm")
    },
    currentPrice() {
      return this.price?.price
    },
    diff() {
      return this.price?.diff
    },
    per() {
      return this.price?.per
    },
    volume() {
      return this.price?.volume
    },
    value() {
      return this.price?.value
    },
    isUp() {
      return (this.price?.diff || 0) > 0
    },
    isDown() {
      return (this.price?.diff || 0) < 0
    },
    pClass() {
      if(this.isUp) {
        return 'up'
      }else
      if(this.isDown) {
        return 'down'
      }else{
        return ''
      }
    },
    icon() {
      if(this.isUp) {
        return 'fa-caret-up'
      }else
      if(this.isDown) {
        return 'fa-caret-down'
      }else{
        return ''
      }
    },
    mStatus() {
      const time = moment(this.price?.time).format('HH:mm')

      if(time === '11:45') {
        return 'Break'
      }else
      if(time === '16:25') {
        return 'Closed'
      }else
      if(moment(this.price?.time).isBetween(`${this.today} 08:59`, `${this.today} 11:45`)) {
        return 'Open'
      }else
      if(moment(this.price?.time).isBetween(`${this.today} 13:29`, `${this.today} 16:25`)) {
        return 'Open'
      }else{
        return 'Closed'
      }
    },
    mClass() {
      return {
        'Break': 'badge-info',
        'Open': 'badge-success',
        'Closed': 'badge-danger'
      }[this.mStatus]
    }
  },
  methods: {
    loadData() {
      LottoService.getPrice()
      .then((response)=>{
        if(response.status === 'success') {
          this.price = response.data
        }
      })
    }
  },
  created() {
    this.loadData()

    this.interval = setInterval(()=>{
      this.loadData()
    }, 35000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
}
</script>
<style lang="scss" scoped>
.stripe-main {
  z-index: 3;
  display: block;
  position: relative;
  // height: 120px;
  background-color: #FFFFFF;

  h2, h3 {
    margin-bottom: 0;
  }

  .row-price {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .price {
      padding-top: 10px;
    }
  }

  .up {
    .fas {
      color: green;
    }

    .price {
      color: green;
    }
  }

  .down {
    .fas {
      color: red;
    }

    .price {
      color: red;

      // span:before {
      //   content: "-";
      // }
    }
  }
}

@media only screen and (max-width:991px) {
  .col-sm-6 {

    .row-price {
      flex-direction: column;

      .price {
        display: flex;
        padding-top: 0;
        width: 100%;
        justify-content: flex-end;
      }
    }
  }
}

@media only screen and (max-width:767px) {
  .col-sm-6 {
    .row-price {
      .price {
        justify-content: flex-start;
      }
    }
  }
}

@media only screen and (max-width:575px) {
  .col-sm-6 {
    flex: 0 0 100%;
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #EEEEEE;

    .row-price {
      width: 100%;
      margin-bottom: 10px;
      display: flex;

      h2 {
        width: auto;
      }
    }

    h3 {
      font-size: 22px;
    }
  }
}
</style>
